'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBody = require('react-bootstrap/lib/ModalBody');

var _ModalBody2 = _interopRequireDefault(_ModalBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ModalBody2.default;